import { api, useApi } from '@gik/core/api';
import { ResponsePromise } from 'ky';
import { SelectOptionsType } from '@gik/ui';

const PATH = 'inkinds';

export interface FeaturedPage {
  title: string;
  location: string;
  imgSrc: string;
  routeId: string;
  slug: string;
}

export default async function getFeaturedPages(categoryId: number): Promise<FeaturedPage[]> {
  const apiResponse: ResponsePromise = api(PATH, { method: 'GET', searchParams: { 'featured-category': categoryId } });
  return await apiResponse.json<FeaturedPage[]>();
}

export function useFeaturedPages(category?: string): { data: FeaturedPage[] } {
  const { data: pageResponse } = useApi<FeaturedPage[]>(category ? PATH : null, null, {
    searchParams: { 'featured-category': category },
  });
  return { data: pageResponse };
}
